import React from 'react';
import PropTypes from 'prop-types';
import { DANGER, WARNING, SUCCESS, INFO, propsUtil, svgUtil } from '@asphalt-react/helper';

const {
  createPropOccurValidator
} = propsUtil;

const Icontuner = ({
  size,
  children,
  danger,
  warning,
  info,
  success,
  muted,
  brand,
  disabled
}) => {
  /**
   * Returns icon with tuned height and width
   * according to the size applied
   *
   * @param {string} size
   */
  const iconSize = size => {
    switch (size) {
      case "s":
        return {
          height: "14",
          width: "14"
        };

      case "m":
        return {
          height: "16",
          width: "16"
        };

      default:
        return {
          height: "16",
          width: "16"
        };
    }
  };

  const validateColor = createPropOccurValidator([DANGER, WARNING, SUCCESS, INFO, "muted", "brand", "disabled"]);
  const valid = validateColor({
    danger,
    warning,
    success,
    info,
    muted,
    brand,
    disabled
  });
  /**
   * Returns token value respective to props applied
   */

  const token = () => {
    if (!valid) {
      console.warn("Invalid or multiple options might be applied, default styles applied");
      return "var(--icon-primary,hsla(220, 42%, 24%, 1))";
    }

    if (danger) return "var(--support-danger-default,hsla(12, 92%, 45%, 1))";
    if (warning) return "var(--support-warning-default,hsla(33, 100%, 56%, 1))";
    if (info) return "var(--support-info-default,hsla(209, 100%, 42%, 1))";
    if (success) return "var(--support-success-default,hsla(159, 97%, 27%, 1))";
    if (muted) return "var(--icon-muted,hsla(219, 23%, 60%, 1))";
    if (brand) return "var(--icon-brand,hsla(127, 100%, 33%, 1))";
    if (disabled) return "var(--icon-disabled,hsla(0, 0%, 62%, 1))";
    return "var(--icon-primary,hsla(220, 42%, 24%, 1))";
  };
  /**
   * Clones original icon and tunes
   * the icon according to the applied props.
   */


  const tuneIcon = () => {
    if ( /*#__PURE__*/React.isValidElement(children) && svgUtil.isSVG(children)) {
      const type = children.props && children.props.originalType || children.type;
      const icon = typeof type === "function" ? type() : type;
      let updatesize = /*#__PURE__*/React.cloneElement(icon, iconSize(size));
      return /*#__PURE__*/React.cloneElement(updatesize, {
        style: {
          color: token()
        }
      });
    } else {
      console.warn("Invalid Icon");
      return children;
    }
  }; // Need to wrap the function inside a fragment to generate docs refer to https://github.com/reactjs/react-docgen/issues/336


  return /*#__PURE__*/React.createElement(React.Fragment, null, tuneIcon());
};
Icontuner.propTypes = {
  /**
   * Icon
   */
  children: PropTypes.node.isRequired,

  /**
   * size of the icon. accepts s, m for small & medium
   */
  size: PropTypes.oneOf(["s", "m"]),

  /**
   * Applies danger style color to icon
   */
  danger: PropTypes.bool,

  /**
   * Applies warning style color to icon
   */
  warning: PropTypes.bool,

  /**
   * Applies info style color to icon
   */
  info: PropTypes.bool,

  /**
   * Applies success style color to icon
   */
  success: PropTypes.bool,

  /**
   * Applies muted style color to icon
   */
  muted: PropTypes.bool,

  /**
   * Applies brand style color to icon
   */
  brand: PropTypes.bool,

  /**
   * Applies disabled style color to icon
   */
  disabled: PropTypes.bool
};
Icontuner.defaultProps = {
  size: "m"
};

export default Icontuner;
